import React, {Component} from 'react';
import CSSModules from 'react-css-modules'
import config from 'config'
import container from '../../helpers/container'
import { Link as ScrollLink } from 'react-scroll'
import {
  ContainerDivs,
  Link,
  LinkIcon,
  ScrollToTop
} from '../../components'
import Styles from './Methodology.css'

@CSSModules(Styles, {allowMultiple: true})
export default class Methodology extends Component {
  constructor(props) {
    super(props)
    this.state = {
      title: 'Methodology',
      description: 'Methodology for the Retirement Plan Sustainability Scorecard',
      url: config.domain + config.routes.methodology
    }
  }

  render() {
    const fffIcon = require( '../../../static/images/icons/fff-icn-clr.png' )
    const ffbIcon = require( '../../../static/images/icons/ffb-icon.svg'     )
    const ffiIcon = require( '../../../static/images/icons/ffi-icon.svg'     )
    const dffIcon = require( '../../../static/images/icons/dff-icn-clr.png' )
    const gefIcon = require( '../../../static/images/icons/gef-icn-clr.png' )
    const gffIcon = require( '../../../static/images/icons/gff-icn-clr.png' )
    const pffIcon = require( '../../../static/images/icons/pff-icn-clr.png' )
    const wffIcon = require( '../../../static/images/icons/wff-icn-clr.png' )
    const tffIcon = require( '../../../static/images/icons/tff-icn-clr.png' )

    // const graySquare = (
    //   <div styleName='result-shape-txt-wrap'>
    //     <div styleName='result-shape-wrap'>
    //       <div title='Coming soon' styleName='gray-square'/>
    //     </div>
    //     <div styleName='result-val result-val-soon'>
    //       Coming soon
    //     </div>
    //   </div>
    // )

    const redOctagon = (
      <div styleName='result-shape-txt-wrap'>
        <div styleName='result-shape-wrap'>
          <div title='Poor' styleName='red-octagon'/>
        </div>
        <div styleName='result-val result-val-poor'>
          Poor
        </div>
      </div>
    )

    const yellowSquare = (
      <div styleName='result-shape-txt-wrap'>
        <div styleName='result-shape-wrap'>
          <div title='Fair' styleName='yellow-square'/>
        </div>
        <div styleName='result-val result-val-fair'>
          Fair
        </div>
      </div>
    )

    const greenCircle = (
      <div styleName='result-shape-txt-wrap'>
        <div styleName='result-shape-wrap'>
          <div title='Good' styleName='green-circle'/>
        </div>
        <div styleName='result-val result-val-good'>
          Good
        </div>
      </div>
    )

    //
    return (
      <div styleName='page' id='top'>
        {
          container.helmet(
            this.state.title,
            this.state.description,
            this.state.url
          )
        }
        <ContainerDivs>
          <div styleName='anchor' id='top'/>

          <h1 styleName='small-page-title'>
            {this.state.title}
          </h1>

          <div styleName='methodology-wrap'>
            <p>We designed the retirement plan sustainability scorecard around
            three questions:</p>

            <p styleName='indent'><b>What are the environmental and social sustainability risks of the
            default plan option?</b></p>

            <p styleName='indent'><b>How much money do plan participants have invested in different sustainability
            risk categories?</b></p>

            <p styleName='indent'><b>Do plan participants have any access to sustainable investments?</b></p>

            <p>To answer these questions, we find out
            what funds are offered by the retirement plan, and what companies those funds
            are invested in.</p>

            <nav>
              {
                [
                  [0, 'How retirement plans are structured', 'retirement-plans'],
                  [0, 'Qualified Default Investment Alternatives (QDIAs)', 'qdia'],
                  [0, 'Target date funds', 'target-dates'],
                  [0, 'Mutual funds', 'mutual-funds'],
                  [0, 'Companies', 'companies'],
                  [1, 'Publicly-traded companies', 'publicly-traded-companies'],
                  [0, 'Rating mutual funds', 'rating-mutual-funds'],
                  [1, 'Fossil fuel grade', 'fossil-fuel-grade'],
                  [1, 'Fossil finance grade', 'fossil-finance-grade'],
                  [1, 'Fossil insurance grade', 'fossil-insurance-grade'],
                  [1, 'Deforestation grade', 'deforestation-grade'],
                  [1, 'Gender equality grade', 'gender-equality-grade'],
                  [1, 'Civilian firearm grade', 'civilian-firearms-grade'],
                  [1, 'Prison industrial complex grade', 'prison-industrial-complex-grade'],
                  [1, 'Military weapons grade', 'military-weapons-grade'],
                  [1, 'Tobacco grade', 'tobacco-grade'],
                  [1, 'Portfolio analysis details', 'portfolio-analysis-details'],
                  [0, 'Rating target date funds', 'rating-target-date-funds'],
                  [1, 'Why the 2050 fund?', 'why-2050'],
                  [0, 'Rating retirement plans based on the default investment', 'rating-retirement-plan-default'],
                  [1, 'Why is the default investment option so important?', 'why-default-is-important'],
                  [0, 'Retirement plan options beyond the default investment', 'retirement-plan-options-beyond-default'],
                  [1, 'Collective trusts', 'collective-trusts'],
                  [0, 'Calculating retirement plan allocations to sustainability risks', 'allocations-sustainability-risks'],
                  [0, 'Identifying whether retirement plans offer access to sustainable options', 'sustainable-options'],
                  [1, 'Self-directed option', 'self-directed-option'],
                  [0, 'Source data', 'source-data']
                ].map((e, i)=>{
                  return (
                    <button
                      key={e[2]}
                      styleName='scroll-to-item'
                    >
                      <ScrollLink
                        to={e[2]}
                        spy
                        smooth
                        duration={500}
                        title={e[1]}
                      >
                        <p styleName={'level-'+e[0]}>{e[1]}</p>
                      </ScrollLink>
                    </button>
                  )
                })
              }
            </nav>


            <div styleName='anchor' id='retirement-plans'/>
            <h2>How retirement plans are structured</h2>

            <p>Most retirement plans are structured as a list of 10-20
            investment options. When a plan participant chooses to allocate their
            contributions to one or more of these investment options, that money is then
            invested by the fund managers into the stock market.</p>

            <p>These types of retirement plans are called <Link xstrong to="https://www.investopedia.com/terms/d/definedcontributionplan.asp">defined
            contribution plans</Link>. The most common type of defined contribution plan is
            the 401(k); another common type is the 403(b). Both of these plan types give
            participants the ability to choose for themselves which plan options to invest
            in.</p>

            <p>There are often tax advantages to investing via a defined
            contribution plan. However, defined contribution plans require employees to
            invest and manage their own money in order to save up enough for retirement
            later in life. This means, depending on the investments chosen, a plan
            participant may have more or less financial risk.</p>

            <ScrollToTop />
            <hr/>


            <div styleName='anchor' id='qdia'/>
            <h2>Qualified Default Investment Alternatives (QDIAs)</h2>

            <p>To help plan participants manage that financial risk, most
            defined contribution plans have a default investment option, where any new
            participants have contributions allocated unless they specify otherwise. This
            default option is known as the <Link xstrong to="https://www.betterment.com/resources/what-is-a-qualified-default-investment-alternative-qdia/">Qualified
            Default Investment Alternative</Link>, or QDIA.</p>

            <p>A plan QDIA must meet certain requirements from the Department
            of Labor (DOL), and these funds are usually diversified investments that invest
            broadly in global stock markets. They’re designed to make sure that any new
            plan participant can feel relatively secure choosing that option to save for
            their retirement.</p>

            <p>Some plans use a balanced fund (a fund that invests partly
            in stocks, partly in bonds) as the QDIA. But a more common option, especially
            in plans from large companies with a significant amount of assets under
            management, are a type of investment fund called target date funds.</p>

            <ScrollToTop />
            <hr/>


            <div styleName='anchor' id='target-dates'/>
            <h2>Target date funds</h2>

            <p><Link xstrong to="https://www.investopedia.com/terms/t/target-date_fund.asp">Target date
            funds</Link> are broadly diversified investments, similar to balanced funds,
            but they are offered as a series of funds, aimed at different “target
            dates”.</p>

            <p>As a plan participant moves closer to retirement, they often
            prefer safer portfolios. Nobody wants to arrive at retirement and find out
            their savings have been lessened at the last moment due to risky investments.
            But when retirement is further away, introducing more risk can be a way to
            achieve greater gains, with the knowledge that any risk-related losses could be
            offset by the additional time in market.</p>

            <p>Target date fund series offer funds aimed at different
            “target dates”, marketed to savers who are planning to retire around those
            dates. For example, someone looking to retire in the year 2030 would invest in the
            2030 version of a target date fund; someone younger expecting to retire in the
            year 2060 would invest in the 2060 version.</p>

            <p>As that “target date” year comes closer in time, the
            portfolio moves away from riskier investments like stocks, and invests more in
            safer investments like bonds. This gives the plan participant the security of
            knowing that even if they keep their savings in that fund throughout their working
            career, the fund manager is working behind the scenes to manage risk
            appropriate to their circumstances. This is what makes them good candidates for
            retirement plan default options.</p>

            <p>These target date funds often don’t invest directly in
            stocks, but invest in other <Link xstrong to="https://www.investopedia.com/terms/m/mutualfund.asp">mutual funds</Link> (usually from the same asset manager to reduce fees). For example, here are the
            holdings of a very popular target date fund, the <Link xstrong to="https://investor.vanguard.com/mutual-funds/profile/portfolio/vfifx">Vanguard
            Target Retirement 2050 fund</Link>:</p>

            <p styleName='indent'>1. Vanguard Total Stock Market Index
            Fund – 54%</p>

            <p styleName='indent'>2. Vanguard Total International
            Stock Index Fund – 36.5%</p>

            <p styleName='indent'>3. Vanguard Total Bond Market II
            Index Fund – 6.5%</p>

            <p styleName='indent'>4. Vanguard Total International Bond
            Index Fund – 2.9%</p>

            <p styleName='indent'>5. Vanguard Total International Bond
            II Index – 0.1% </p>

            <p>The other target dates offered by this target and series
            will usually invest in the same portfolio of funds, but with different
            allocations to the stock funds and bond funds (more in bonds for dates closer
            to today, more in stocks for dates further out).</p>

            <ScrollToTop />
            <hr/>


            <div styleName='anchor' id='mutual-funds'/>
            <h2>Mutual funds</h2>

            <p>This means that to find out what the Vanguard Target
            Retirement 2050 fund is investing in, we need to know what the “funds inside the
            fund” are invested in.</p>

            <p>Since 2015, As You Sow’s <Link xstrong to="https://fossilfreefunds.org/">Fossil Free Funds</Link> has been analyzing the holdings of mutual funds and rating them on fossil fuel
            investments and overall carbon footprint. Our fund screeners are 100% free to
            use, and provide transparency to find out if mutual funds are investing in
            oil majors like ExxonMobil and Chevron, coal mining companies
            like BHP, and fossil-fired utilities like Duke Energy.</p>

            <p>Since we released Fossil Free Funds, we’ve expanded our
            sustainability ratings to include <Link xstrong to="https://deforestationfreefunds.org/">deforestation</Link>,
            as well as social issues like <Link xstrong to="https://genderequalityfunds.org/">gender
            equality</Link>, <Link xstrong to="https://gunfreefunds.org/">civilian firearms</Link>, <Link xstrong to="https://prisonfreefunds.org/">the prison industrial complex</Link>, <Link xstrong to="https://weaponfreefunds.org/">arms manufacturers and military contractors</Link>,
            and <Link xstrong to="https://tobaccofreefunds.org/">tobacco</Link>.</p>

            <p>For each of these issues, we produce ratings for mutual
            funds based on what stocks the fund is invested in. The first step is to
            determine which companies have sustainability risks for these issues.</p>

            <ScrollToTop />
            <hr/>


            <div styleName='anchor' id='companies'/>
            <h2>Companies</h2>

            <p>Most people have heard of oil giants like ExxonMobil. But
            the fossil fuel industry includes many smaller companies that people haven’t
            heard of, and if they were to take the time to dig into the fund portfolio,
            they might not recognize as fossil fuel companies. This includes pipeline companies,
            oil field services, gas utilities, and more.</p>

            <p>For other issues, the sustainability risks are even harder
            to investigate. Companies that have poor gender balance in their workforce, for
            example, are usually not anxious to make this known to their investors.
            Companies with contracts to provide services to prisons and immigration
            jails may seem innocuous without this transparency.</p>

            <p>To identify companies within a fund portfolio as
            sustainability risks, we depend on research from investor research firms and
            non-profit advocacy groups. A full breakdown of the various company screens we
            track <Link to={config.routes.companies} xstrong>can be found
            here.</Link></p>

            <div styleName='indent'>

              <div styleName='anchor' id='publicly-traded-companies'/>
              <h3>Publicly-traded companies</h3>

              <p>There are many types of companies with sustainability risks
              currently operating, including privately held and state-owned companies.
              Because our analysis is based on tracking stock investments by mutual funds and
              retirement plans, our company lists are composed of publicly-traded companies
              that issue stock.</p>

            </div>


            <ScrollToTop />
            <hr/>

            <div styleName='anchor' id='rating-mutual-funds'/>
            <h2>Rating mutual funds</h2>

            <p>Once we’ve found a dataset that identifies companies with
            sustainability risks for a given issue, we’re ready to rate mutual funds and <Link xstrong to="https://www.investopedia.com/terms/e/etf.asp">exchange-traded funds
            (ETFs)</Link>.</p>

            <p>We produce letter grade ratings for mutual funds on
            different sustainability issues: fossil fuels, deforestation, gender equality,
            civilian firearms, arms manufacturers and military contractors, and tobacco.</p>

            <p>The rating methodology for each issue is based on the
            company data we have available, and the way funds across our research universe
            invest in those companies.</p>

            <div styleName='indent'>

              <div styleName='anchor' id='fossil-fuel-grade'/>
             <img
               src={fffIcon}
               styleName='icn'
               alt='Fossil fuels'
             />

              <h3>Fossil fuel grade</h3>

              <p>The fossil fuel grade is based on the fund’s exposure to <Link to={config.routes.companies + '#fossilfuels'} xstrong>five fossil
              fuel screen lists</Link>, tracking several thousand companies primarily in the energy and utility
              sectors.</p>

              <div styleName='higher-risk-wrap'>
                <p styleName='higher-risk-icon'>
                  <LinkIcon nospace faclass='fa-exclamation-triangle' />
                </p>
                <p>Two of the screens - top carbon reserve owners and top coal-fired utilities - are considered <b>higher risk</b>. Investment in these companies automatically earns a fund a fossil fuel grade of C or lower.</p>
              </div>

              <p>The grade also incorporates investments in <Link to={config.routes.companies + '#fossilfinance'} xstrong>banks financing fossil fuels</Link> and <Link to={config.routes.companies + '#fossilinsurance'} xstrong>insurers underwriting fossil fuels</Link>.</p>

              <p>If a fund doesn't invest in any of the fossil fuel companies or related financial companies we look
              for, it earns an A grade. </p>

              <p styleName='indent'><b styleName='grade-a'>A</b> Fossil fuel exposure is 0%, fossil fuel finance and insurance exposure is 0%</p>

              <p>If a fund has investments in fossil fuel companies or related financial companies, we
              measure the percentage of exposure to assign a grade.</p>

              <p styleName='indent'><b styleName='grade-b'>B</b> Fossil fuel exposure between 0% and 3%; OR, fossil fuel exposure is 0%, fossil fuel finance and insurance exposure above 0%</p>

              <p styleName='indent'><b styleName='grade-c'>C</b> Fossil fuel exposure between 3% and 5.5%; OR, fossil fuel exposure below 3%, with investments in top 200 carbon reserve owners and/or top 30 coal-fired utilities</p>

              <p styleName='indent'><b styleName='grade-d'>D</b> Fossil fuel exposure between 5.5% and 9%</p>

              <p styleName='indent'><b styleName='grade-f'>F</b> Fossil fuel exposure between 9% and 100%</p>

              <p>These percentage thresholds reflect the distribution of results across funds, placing a roughly equal number of funds from the analysis universe in each grade range.</p>

            </div>

            <ScrollToTop />
            <hr/>


            <div styleName='indent'>

              <div styleName='anchor' id='fossil-finance-grade'/>
             <img
               src={ffbIcon}
               styleName='icn'
               alt='Fossil finance'
             />

              <h3>Fossil finance grade</h3>

              <p>The fossil finance grade is based on the fund’s exposure to <Link to={config.routes.companies + '#fossilfinance'} xstrong>banks that lend to fossil fuels.</Link> It is a standalone grade, and also impacts the fund's fossil fuel grade.</p>
              <p>
                To rate mutual funds on fossil fuel finance, we use
                data from <Link
                  to='https://www.bankingonclimatechaos.org/'
                  title='Banking on Climate Chaos'
                  xstrong
                >
                  Banking on Climate Chaos
                </Link>.
                The Banking on Climate Chaos report looks at 65 of the largest
                commercial and investment banks
                and tracks their total fossil fuel financing:
                lending, and underwriting
                debt and equity issuances.
                The data covers 2021 through 2024. The top bank, JPMorgan Chase, had
                over 192 billion in fossil fuel financing over this time period.
                For our fund ratings, we normalize the bank financing
                amounts from $USD to a 0-10
                scale, where 10 is the worst score possible.
                These 0-10 figures represent a <b>company fossil fuel finance risk score</b>.
              </p>
              <p>
                We then use the normalized financing amounts to calculate a <b>
                fund fossil fuel finance risk score</b>.
                For each flagged bank holding, the company risk score is multiplied
                by the holding weight (the percent of the fund's portfolio
                that holding accounts for). For example, if a flagged bank
                holding had a company risk score of 5, and made up 2% of the
                fund, 10 points would be assigned to the fund (5 times 2).
                These points are summed up and represent the fund fossil fuel
                finance risk score.
              </p>
              <p>
                The last step is using the fund risk score to assign a <b>
                fund fossil fuel finance grade</b>.
              </p>

              <p>If a fund doesn't invest in any of the fossil finance companies we look
              for, it earns an A grade.</p>

              <p styleName='indent'><b styleName='grade-a'>A</b> Fossil finance exposure is 0%</p>

              <p>If a fund has investments in fossil finance companies, the fund risk score is used to assign a grade. Funds are grouped into 4 tiers:</p>

              <p styleName='indent'><b styleName='grade-b'>B</b> Fossil finance score in 0 - 11 range</p>

              <p styleName='indent'><b styleName='grade-c'>C</b> Fossil finance score in 11 - 22 range</p>

              <p styleName='indent'><b styleName='grade-d'>D</b> Fossil finance score in 22 - 35 range</p>

              <p styleName='indent'><b styleName='grade-f'>F</b> Fossil finance score in 35+ range</p>

            </div>

            <ScrollToTop />
            <hr/>


            <div styleName='indent'>

              <div styleName='anchor' id='fossil-insurance-grade'/>
             <img
               src={ffiIcon}
               styleName='icn'
               alt='Fossil insurance'
             />

              <h3>Fossil insurance grade</h3>

              <p>The fossil insurance grade is based on the fund’s exposure to <Link to={config.routes.companies + '#fossilinsurance'} xstrong>insurance companies that underwrite and invest in fossil fuels.</Link> It is a standalone grade, and also impacts the fund's fossil fuel grade.</p>

              <p>
                To rate mutual funds on fossil fuel insurance, we use
                data from the <Link
                  to='https://docs.google.com/spreadsheets/d/157kNo3-xg7qeVHi8SF21VqjXKrSjHixL9UOKFTp8PKQ/edit#gid=769793980'
                  title='Insure Our Future Scorecard'
                  xstrong
                >
                  Insure Our Future Scorecard
                </Link>. The Insure Our Future Scorecard looks at 30 of the largest
                primary insurers and reinsurers and rates their fossil fuel
                insurance policies.
                For our fund ratings, we normalize the insurance policy ratings
                 to a 0-10
                scale, where 10 is the worst score possible.
                These 0-10 figures represent a <b>company fossil fuel
                insurance risk score</b>.
              </p>
              <p>
                We then use the normalized policy ratings to calculate a <b>
                fund fossil fuel insurance risk score</b>. For each flagged
                insurance holding, the company risk score is multiplied
                by the holding weight (the percent of the fund's portfolio
                that holding accounts for). For example, if a flagged insurance
                holding had a company risk score of 5, and made up 2% of the
                fund, 10 points would be assigned to the fund (5 times 2).
                These points are summed up and represent the fund fossil fuel
                insurance risk score.
              </p>
              <p>
                The last step is using the fund risk score to assign a <b>
                fund fossil fuel insurance grade</b>.
              </p>

              <p>If a fund doesn't invest in any of the fossil insurance companies we look
              for, it earns an A grade.</p>

              <p styleName='indent'><b styleName='grade-a'>A</b> Fossil insurance exposure is 0%</p>

              <p>If a fund has investments in fossil insurance companies, the fund risk score is used to assign a grade. Funds are grouped into 4 tiers:</p>

              <p styleName='indent'><b styleName='grade-b'>B</b> Fossil insurance score in 0 - 9 range</p>

              <p styleName='indent'><b styleName='grade-c'>C</b> Fossil insurance score in 9 - 16 range</p>

              <p styleName='indent'><b styleName='grade-d'>D</b> Fossil insurance score in 16 - 24 range</p>

              <p styleName='indent'><b styleName='grade-f'>F</b> Fossil insurance score in 24+ range</p>

            </div>

            <ScrollToTop />
            <hr/>


            <div styleName='indent'>

              <div styleName='anchor' id='deforestation-grade'/>
             <img
               src={dffIcon}
               styleName='icn'
               alt='Deforestation'
             />

              <h3>Deforestation grade</h3>

              <p>The deforestation grade is based on the fund’s exposure to a <Link to={config.routes.companies + '#deforestation'} xstrong>list of deforestation-risk
              companies</Link> identified
              in partnership with <Link xstrong to="https://foe.org/">Friends of the Earth U.S.</Link>,
              compiled from independent research as well as from existing resources within
              the civil society research and investor advocacy communities on forest-risk
              companies, including <Link xstrong to="https://forestsandfinance.org/" target="_blank"
              title="Forests &amp; Finance">Forests &amp; Finance</Link>, <Link xstrong to="https://forest500.org/" target="_blank" title="Forest500">Forest500</Link>, <Link xstrong to="https://www.cdp.net/en/forests" target="_blank" title="CDP Forests">CDP
              Forests</Link>, <Link xstrong to="https://supply-change.org/" target="_blank"
              title="Supply Change.org">Supply Change.org</Link> and <Link xstrong to="https://www.spott.org/" target="_blank" title="ZSL SPOTT">ZSL SPOTT</Link>.
              The screens include deforestation-risk agricultural commodity producer/traders
              (palm oil, paper/pulp, rubber, timber, cattle, and soy); financial companies
              involved in lending and underwriting to deforestation-risk producers and
              traders; and major consumer goods companies that source from deforestation-risk
              producers and traders.</p>

              <div styleName='higher-risk-wrap'>
                <p styleName='higher-risk-icon'>
                  <LinkIcon nospace faclass='fa-exclamation-triangle' />
                </p>
                <p>The deforestation-risk producer/trader screen is considered <b>higher risk</b>. Investment in these companies automatically earns a fund a deforestation grade of C or lower.</p>
              </div>

              <p>If a fund doesn't invest in any of the deforestation-risk
              companies we look for, it earns an A grade.</p>

              <p styleName='indent'><b styleName='grade-a'>A</b> Deforestation-risk
              screens exposure 0%</p>

              <p>The screens are split into two tiers, with investments in
              producer/traders considered a higher risk. If a fund doesn’t invest in any of
              the deforestation-risk producer/traders, but has investments in the financial
              companies or major consumer brands screens, it earns a B grade.</p>

              <p styleName='indent'><b styleName='grade-b'>B</b> Deforestation-risk
              producer/trader screen exposure 0%; has investments in banks and lenders
              and/or major consumer brands</p>

              <p>If a fund has investments in deforestation-risk
              producer/trader companies, we measure the percentage of exposure to assign a
              grade.</p>

              <p styleName='indent'><b styleName='grade-c'>C</b> Deforestation-risk
              producer/trader screen exposure between 0% and 0.5%</p>

              <p styleName='indent'><b styleName='grade-d'>D</b> Deforestation-risk
              producer/trader screen exposure between 0.5% and 1.5%</p>

              <p styleName='indent'><b styleName='grade-f'>F</b> Deforestation-risk
              producer/trader screen exposure between 1.5% and 100%</p>

              <p>These brackets reflect the distribution of results across
              funds, placing an approximately equal number of funds from the analysis universe
              in each grade range.</p>

            </div>

            <ScrollToTop />
            <hr/>


            <div styleName='indent'>

              <div styleName='anchor' id='gender-equality-grade'/>
             <img
               src={gefIcon}
               styleName='icn'
               alt='Gender equality'
             />

              <h3>Gender equality grade</h3>

              <p>The gender equality grade is based on corporate data from <Link xstrong to="https://equileap.com/">Equileap</Link> that <Link to={config.routes.companies + '#genderequality'} xstrong>tracks how companies perform</Link> on
              four gender equality subcategories: gender balance in leadership and workforce;
              equal compensation and work life balance; policies promoting gender equality;
              and commitment, transparency, and accountability.</p>

              <p>First, a gender equality fund score is produced by applying
              the Equileap company scores to the fund holdings, then calculating the average
              score weighted by holding weight.</p>

              <p>Then, funds are ranked against other funds in the same
              investment group (U.S. equity funds, international equity funds, sector funds,
              and allocation funds). Based on these group rankings, funds are assigned a
              letter grade.</p>

              <p styleName='indent'><b styleName='grade-a'>A</b> Gender equality group
              ranking between 80% and 100%</p>

              <p styleName='indent'><b styleName='grade-b'>B</b> Gender equality group
              ranking between 60% and 80%</p>

              <p styleName='indent'><b styleName='grade-c'>C</b> Gender equality group
              ranking between 40% and 60%</p>

              <p styleName='indent'><b styleName='grade-d'>D</b> Gender equality group
              ranking between 20% and 40%</p>

              <p styleName='indent'><b styleName='grade-f'>F</b> Gender equality group
              ranking between 0% and 20%</p>

            </div>

            <ScrollToTop />
            <hr/>


            <div styleName='indent'>

              <div styleName='anchor' id='civilian-firearms-grade'/>
             <img
               src={gffIcon}
               styleName='icn'
               alt='Civilian firearms'
             />

              <h3>Civilian firearm grade</h3>

              <p>The civilian firearm grade is based on the fund’s exposure
              to <Link to={config.routes.companies + '#civilianfirearms'} xstrong>two screen
              lists</Link>:
              civilian firearm manufacturers, and retailers that sell firearms or ammunition
              to the civilian market.</p>

              <div styleName='higher-risk-wrap'>
                <p styleName='higher-risk-icon'>
                  <LinkIcon nospace faclass='fa-exclamation-triangle' />
                </p>
                <p>The civilian firearm manufacturers screen is considered <b>higher risk</b>. Investment in these companies automatically earns a fund a civilian firearm grade of C or lower.</p>
              </div>

              <p>If a fund doesn't invest in any of the companies from the civilian
              firearm screens, it earns an A grade.</p>

              <p styleName='indent'><b styleName='grade-a'>A</b> Civilian firearm screens
              exposure 0%</p>

              <p>The screens are split into two tiers, with investments in civilian
              firearm manufacturers considered a higher risk. If a fund doesn’t invest in any
              of the civilian firearm manufacturers, but has investments in the civilian firearm
              retailers screen, it earns a B grade.</p>

              <p styleName='indent'><b styleName='grade-b'>B</b> Civilian firearm manufacturers
              screen exposure 0%; has investments in civilian firearm retailers</p>

              <p>If a fund has investments in civilian firearm manufacturers,
              we measure the percentage of exposure to assign a grade.</p>

              <p styleName='indent'><b styleName='grade-c'>C</b> Civilian firearm manufacturers
              screen exposure between 0% and 0.1%</p>

              <p styleName='indent'><b styleName='grade-d'>D</b> Civilian firearm manufacturers
              trader screen exposure between 0.1% and 0.4%</p>

              <p styleName='indent'><b styleName='grade-f'>F</b> Civilian firearm manufacturers
              screen exposure between 0.4% and 100%</p>

              <p>These brackets reflect the distribution of results across
              funds, placing an approximately equal number of funds from the analysis universe
              in each grade range.</p>

            </div>

            <ScrollToTop />
            <hr/>


            <div styleName='indent'>

              <div styleName='anchor' id='prison-industrial-complex-grade'/>
             <img
               src={pffIcon}
               styleName='icn'
               alt='Prison industrial complex'
             />

              <h3>Prison industrial complex grade</h3>

              <p>The prison industrial complex grade is based on the fund’s
              exposure to <Link to={config.routes.companies + '#prisonindustrialcomplex'} xstrong>two
              screen lists</Link>:
              prison industry companies, and border industry companies. All the companies on
              both lists are identified by the <Link xstrong to="https://investigate.afsc.org/">American
              Friends Service Committee’s Investigate project</Link>.</p>

              <div styleName='higher-risk-wrap'>
                <p styleName='higher-risk-icon'>
                  <LinkIcon nospace faclass='fa-exclamation-triangle' />
                </p>
                <p>The prison industrial complex-risk screens have a number of companies considered <b>higher risk</b>. Investment in these companies automatically earns a fund a prison industrial complex grade of C or lower.</p>
              </div>

              <br/>

              <div styleName='higher-risk-wrap'>
                <p styleName='higher-risk-icon red'>
                  <LinkIcon nospace faclass='fa-exclamation-triangle' />
                </p>
                <p>There are also a number of private prison operators that are considered <b styleName='red'>extreme risk</b>. Investment in these companies automatically earns a fund a prison industrial complex grade of F.</p>
              </div>

              <p>If a fund doesn't invest in any of the prison industrial
              complex-risk companies we look for, it earns an A grade.</p>

              <p styleName='indent'><b styleName='grade-a'>A</b> Prison industrial complex-risk
              screens exposure 0%</p>

              <p>The screens are split into two tiers, with both the prison
              industry and border industry screens having a subset of companies considered a
              higher risk. If a fund has investments in the prison industrial complex screens,
              but doesn’t invest in any of the higher-risk companies, it earns a B grade.</p>

              <p styleName='indent'><b styleName='grade-b'>B</b> Prison industrial complex
              higher risk screens exposure 0%; has investments in other prison industrial
              complex companies</p>

              <p>If a fund has investments in the higher-risk companies from
              the prison industrial screens, we measure the percentage of exposure to assign
              a grade.</p>

              <p styleName='indent'><b styleName='grade-c'>C</b> Prison industrial complex
              higher risk screens exposure between 0% and 1%</p>

              <p styleName='indent'><b styleName='grade-d'>D</b> Prison industrial complex
              higher risk screens exposure between 1% and 2%</p>

              <p styleName='indent'><b styleName='grade-f'>F</b> Prison industrial complex
              higher risk screens exposure between 2% and 100%</p>

              <p>These brackets reflect the distribution of results across
              funds, placing an approximately equal number of funds from the analysis universe
              in each grade range.</p>

              <p>In addition, because the private operation of prison and jails represents the deepest form of corporate involvement in mass incarceration, any investments in the private prison operators screen earns an automatic F.</p>

              <p styleName='indent'><b styleName='grade-f'>F</b> Private prison operators screen
              exposure between 3% and 100%</p>

            </div>

            <ScrollToTop />
            <hr/>


            <div styleName='indent'>

              <div styleName='anchor' id='military-weapons-grade'/>
             <img
               src={wffIcon}
               styleName='icn'
               alt='Military weapons'
             />

              <h3>Military weapons grade</h3>

              <p>The military weapons grade is based on the fund’s exposure
              to <Link to={config.routes.companies + '#militaryweapons'} xstrong>arms manufacturers and military contractors.</Link> This list includes two sub-categories: manufacturers and servicers of nuclear weapons; and current and recent manufacturers of controversial weapons, such as cluster munititions, anti-personnel landmines, incendiary weapons, and depleted uranium.</p>

              <div styleName='higher-risk-wrap'>
                <p styleName='higher-risk-icon'>
                  <LinkIcon nospace faclass='fa-exclamation-triangle' />
                </p>
                <p>The nuclear weapons and controversial weapons lists are considered <b>higher risk</b>. Investment in these companies automatically earns a fund a military weapons grade of C or lower.</p>
              </div>

              <p>If a fund doesn't invest in any of the military weapons
              companies we look for, it earns an A grade. </p>

              <p styleName='indent'><b styleName='grade-a'>A</b> Military weapons screens
              exposure 0%</p>

              <p>The lists are split into two tiers, with companies involved in nuclear weapons and controversial weapons considered a
              higher risk. If a fund has investments in the military weapons list,
              but doesn’t invest in any of the higher-risk companies, it earns a B grade.</p>

              <p styleName='indent'><b styleName='grade-b'>B</b> Fund is not invested in nuclear weapons or controversial weapons, but is invested in military contractors, below the threshold of 2.5%</p>

              <p>If a fund has investments in the higher-risk companies from
              the military weapons list, we measure the percentage of exposure to assign
              a grade.</p>

              <p styleName='indent'><b styleName='grade-c'>C</b> Fund is invested in nuclear weapons and/or controversial weapons below the threshold of 2.5%</p>

              <p styleName='indent'><b styleName='grade-d'>D</b> Fund is invested in military contractors above the threshold of 2.5% and below the threshold of 4%</p>

              <p styleName='indent'><b styleName='grade-f'>F</b> Fund is invested in military contractors above the threshold of 4%</p>

              <p>These brackets reflect the distribution of results across
              funds, placing an approximately equal number of funds from the analysis
              universe in each grade range.</p>

            </div>

            <ScrollToTop />
            <hr/>


            <div styleName='indent'>

              <div styleName='anchor' id='tobacco-grade'/>
             <img
               src={tffIcon}
               styleName='icn'
               alt='Tobacco'
             />

              <h3>Tobacco grade</h3>

              <p>The tobacco grade is based on the fund’s exposure to <Link to={config.routes.companies + '#tobacco'} xstrong>two screen
              lists</Link>: tobacco companies that either produce tobacco or manufacture tobacco
              products identified by industry classifications; and a list of entertainment
              companies that promote tobacco to young audiences, identified by research from
              the <Link xstrong to="https://smokefreemovies.ucsf.edu/whos-accountable" target="_blank"
              title="UCSF Smoke Free Movies Database">University of California, San Francisco
              Center for Tobacco Control Research and Education Smoke Free Movies Database</Link>.</p>

              <div styleName='higher-risk-wrap'>
                <p styleName='higher-risk-icon'>
                  <LinkIcon nospace faclass='fa-exclamation-triangle' />
                </p>
                <p>The tobacco producer/manufacturer screen is considered <b>higher risk</b>. Investment in these companies automatically earns a fund a tobacco grade of C or lower.</p>
              </div>

              <p>If a fund doesn't invest in any of the companies from the tobacco
              screens, it earns an A grade.</p>

              <p styleName='indent'><b styleName='grade-a'>A</b> Tobacco-risk screens
              exposure 0%</p>

              <p>The screens are split into two tiers, with investments in tobacco
              producer/manufacturers considered a higher risk. If a fund doesn’t invest in
              any of the tobacco producer/manufacturers, but has investments in the entertainment
              companies screen, it earns a B grade.</p>

              <p styleName='indent'><b styleName='grade-b'>B</b> Tobacco producer/manufacturers
              screen exposure 0%; has investments in entertainment companies
              that promote tobacco to young audiences</p>

              <p>If a fund has investments in tobacco producer/manufacturers,
              we measure the percentage of exposure to assign a grade.</p>

              <p styleName='indent'><b styleName='grade-c'>C</b> Tobacco
              producer/manufacturers screen exposure between 0% and 0.5%</p>

              <p styleName='indent'><b styleName='grade-d'>D</b> Tobacco
              producer/manufacturers screen exposure between 0.5% and 1.2%</p>

              <p styleName='indent'><b styleName='grade-f'>F</b> Tobacco
              producer/manufacturers screen exposure between 1.2% and 100%</p>

              <p>These brackets reflect the distribution of results across
              funds, placing an approximately equal number of funds from the analysis universe
              in each grade range.</p>

            </div>

            <ScrollToTop />
            <hr/>


            <div styleName='indent'>

            <div styleName='anchor' id='portfolio-analysis-details'/>
            <h3>Portfolio analysis details</h3>

              <p>Long holdings only:
              When calculating a fund's exposure to a screen list, we only consider the
              portfolio's long investments, ignoring any shorts or liabilities. The formula
              for holding weight is <i>holding market value divided by sum of market value
              for all long holdings in the portfolio.</i></p>

              <p>Analysis universe: The fund universe consists of open-end
              mutual funds and exchange-traded funds domiciled in the U.S. Currently, we don’t
              have data on funds domiciled outside the U.S. The fund ratings are based on
              tracking stock investments in publicly-traded companies. Currently, we don’t
              have data on fixed income assets. Because of this, we focus on funds that
              primarily invest in equities. We exclude funds below 50% rated from the
              analysis universe.</p>

            </div>

            <ScrollToTop />
            <hr/>


            <div styleName='anchor' id='rating-target-date-funds'/>
            <h2>Rating target date funds</h2>

            <p>Because target date funds are offered as a series, and
            because they are often structured as “funds of funds”, there are some extra
            steps involved in applying the letter grade rating systems.</p>

            <p>First, we unpack the funds held by the target date fund, and
            re-weight and recombine the holdings to produce a list of stocks held by the
            target date fund. For example, if a target date fund invests in two different
            mutual funds that both invest in ExxonMobil, those two ExxonMobil holdings are
            re-weighted and recombined to represent the total exposure of the target date
            fund to ExxonMobil.</p>

            <p>Second, we use the 2050 version as the representative of the
            target date fund series. For most target date series, the 2050 fund will be
            approximately 90% invested in stocks, 10% invested in bonds and other
            fixed-income assets. Target date series usually have the same mix of stocks
            regardless of which date is chosen, but the percent allocated to stocks overall
            goes down for dates closer to today. This means that, for example, a 2030
            version of a target date fund series will likely have exposure to the same
            companies as the 2050 version, but at lower percentages.</p>

            <div styleName='indent'>

              <div styleName='anchor' id='why-2050'/>
              <h3>Why the 2050 fund?</h3>

              <p>Because our overall retirement plan ratings are based on the
              default investment, and because these default investments are often a target
              date fund series, creating a different retirement plan rating for each version
              of a target date fund series didn’t make sense to us. The 2050 version of a
              target date fund is marketed at savers who are looking to retire in the year
              2050, which is 30 years away, meaning it is usually heavily weighted towards
              stocks vs. other asset classes. Because our analysis is based on tracking stock
              investments, this gives us a good representation of the asset manager’s
              decisions in selecting investments for the target date fund portfolio.</p>

            </div>

            <ScrollToTop />
            <hr/>


            <div styleName='anchor' id='rating-retirement-plan-default'/>
            <h2>Rating retirement plans based on the default
            investment</h2>

            <p>The main scorecard for a retirement plan is based on the
            default investment, because the majority of plan assets tend to be allocated to
            that investment option. For example, the Amazon.com 401(k) has over 50% of
            employee contributions allocated to the Vanguard Target Retirement Fund series
            default option.</p>

            <p>For each issue, we assign a rating of Good,
            Fair, or Poor, depending on how the default option is graded on our mutual fund
            rating systems. (If the default option is a target date fund series, we use the
            2050 version – see above.)</p>

            <div>
             {greenCircle}
            </div>
            <p styleName='indent'>Default option earns a grade of A for this issue.</p>

            <div>
             {yellowSquare}
            </div>
            <p styleName='indent'>Default option earns a grade of B or C for this issue.</p>

            <div>
             {redOctagon}
            </div>
            <p styleName='indent'>Default option earns a grade of D or F for this issue.</p>

            <p>In plain language, if a retirement plan earns a Poor rating
            on an issue, it means that the plan default option has significant exposure to
            companies that have sustainability risk for that issue.</p>

            <div styleName='indent'>

              <div styleName='anchor' id='why-default-is-important'/>
              <h3>Why is the default investment option so important?</h3>

              <p>The default option
              in a defined contribution plan often commands the majority of the plan assets.
              That’s natural, as it’s the option to which new plan participants have their
              contributions allocated, and many people never switch.</p>

              <p>But most employees
              assume the default option in their retirement plan is a safe choice. If climate
              risk and other sustainability issues are not incorporated into the portfolio management
              by the fund manager, employees could be exposed to financial risks from
              unsustainable investments. </p>

              <p>Investing unsustainably carries real
              financial risks. It should be something you have to go out of
              your way to do; not the other way around. Given the scale of our
              sustainability challenges, we must make sustainability the default.</p>

            </div>

            <ScrollToTop />
            <hr/>


            <div styleName='anchor' id='retirement-plan-options-beyond-default'/>
            <h2>Retirement plan options beyond the default
            investment</h2>

            <p>Our retirement plan sustainability scorecard ratings are
            based primarily on the default option. But we also rate the other plan options
            so we can calculate the overall amounts the retirement plan has invested in
            different risk categories.</p>

            <p>For any plan options that are primarily invested in stocks,
            the scorecard will display the environmental and social ratings in the
            “Plan investment options” section.</p>

            <div styleName='indent'>

              <div styleName='anchor' id='collective-trusts'/>
              <h3>Collective trusts</h3>

              <p>Target date fund series and other mutual funds are often offered in a variety of asset classes. A popular asset class for retirement plans are “collective trusts”, which are investments that operate the same way as a mutual fund, but are usually offered only to major investors like pension plans and corporate retirement plans. Collective trusts have fewer transparency requirements, so it’s more difficult to access the investment holdings than it is with mutual funds and ETFs, which have regular disclosure requirements. If a retirement plan offers collective trusts, we identify mutual fund versions of those portfolios to use for calculating the fund ratings and other scorecard results.</p>

            </div>

            <ScrollToTop />
            <hr/>


            <div styleName='anchor' id='allocations-sustainability-risks'/>
            <h2>Calculating retirement plan allocations to sustainability
            risks</h2>

            <p>Using the results of the ratings for the plan default option
            and other plan offerings, we use the most recent available Form 5500 data to
            calculate the overall amounts the retirement plan has invested in different
            risk categories. These totals are shown as a bar chart, with figures listed in
            the “Allocation details” section.</p>

            <p>The risk categories that we sum totals for are:</p>

            <p styleName='indent'>Fossil fuels (including top 200
            carbon reserve owners, Global Coal Exit List, and other oil/gas, coal, and
            utility companies identified by industry classifications)</p>

            <p styleName='indent'>Deforestation-risk agribusiness
            commodity producer/traders (palm oil, cattle, soy, paper/pulp, timber, and
            rubber)</p>

            <p styleName='indent'>Civilian firearm manufacturers</p>

            <p styleName='indent'>Prison industrial complex,
            high-risk (including private prison operators)</p>

            <p styleName='indent'>Arms manufacturers and military
            contractors (including nuclear weapons manufacturers/servicers and
            manufacturers of banned weapons like cluster munitions)</p>

            <p styleName='indent'>Tobacco producer/manufacturers</p>

            <ScrollToTop />
            <hr/>


            <div styleName='anchor' id='sustainable-options'/>
            <h2>Identifying whether retirement plans offer access to
            sustainable options</h2>

            <p>If the default plan option is not a sustainable investment,
            we check to see if there’s any way participants have other access to
            sustainable investing. Some retirement plans do offer a sustainable fund
            option, sometimes labeled as a “socially conscious”, “responsible”, or “ESG”
            option.</p>

            <p>If a retirement plan has a sustainable fund as a plan
            option, we calculate the percent of plan assets allocated to it, and show the
            fund ratings in the “Sustainable plan options” section.</p>

            <div styleName='indent'>

              <div styleName='anchor' id='self-directed-option'/>
              <h3>Self-directed option</h3>

              <p>A self-directed option, also referred to as a brokerage or
              mutual fund window, offers plan participants the ability to invest in much
              larger universe of funds beyond the direct plan options. This expanded universe
              usually includes sustainable funds, so a self-directed option is another way
              retirement plans can offer access to sustainable investments.</p>

              <p>Here’s the issue: a self-directed option moves much of the
              work of selecting investments onto the individual. It also increases the risk
              that participants may choose funds that are not appropriate for their
              circumstances. When they’re available, they’re not commonly used – <Link xstrong to="https://www.investmentnews.com/brokerage-windows-401k-dol-208416">as of
              2020</Link>, about 2.4% of participants in large and medium-sized 401(k)s used a
              self-directed option.</p>

              <p>Retirement plans have a responsibility to offer sustainable
              investments directly in the plan line-up. If a plan doesn’t directly offer any
              sustainable investments, a self-directed option is the only way for
              participants to invest sustainably. If a plan also doesn’t have a self-directed
              option, this effectively forces plan participants to invest unsustainably.</p>

            </div>

            <ScrollToTop />
            <hr/>


            <div styleName='anchor' id='source-data'/>
            <h2>Source data</h2>

            <p>At the bottom of the retirement plan scorecard, there's a section labeled
            "Source data" where the PDFs of the Form 5500 data and other documents
            used in the scorecard analysis are available.</p>

            <ScrollToTop />
            <hr/>


            <br/>
            <br/>
            <br/>
            <br/>
          </div>

        </ContainerDivs>
      </div>
    )
  }
}
